import { j as u } from "../../../../../../../../jsx-runtime.BREq8dyb.js";
import { memo as c } from "react";
import { useDataset as d } from "../../../../../../contexts/DatasetContext/DatasetContext.js";
import "../../../../../../contexts/FeatureContext/FeatureContext.js";
import "../../../../../../contexts/FileContext/FileContext.js";
import "../../../../../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../../../../../contexts/NavigatorContext/NavigatorContext.js";
import { useOptions as l } from "../../../../../../contexts/OptionsContext/OptionsContext.js";
import "../../../../../../contexts/SchemaContext/SchemaContext.js";
import "../../../../../../contexts/TypificationContext/TypificationContext.js";
import "../../../../../../contexts/WorkerContext/WorkerContext.js";
import f from "./components/Indicators/Indicators.js";
const x = c(({
  column: m
}) => {
  const {
    id: n
  } = m, s = parseInt(n), {
    mappedColumns: p
  } = l(), {
    autofixReport: e,
    validationReport: a
  } = d();
  let r, i;
  const o = p.indexOf(s);
  return o !== -1 && (r = a?.report.columns.find(({
    column: t
  }) => t === o), i = e?.report.columnModifications.find(({
    column: t
  }) => t === o)), /* @__PURE__ */ u.jsx(f, { numErrorsTotal: r?.numErrorsTotal, numModificationsTotal: i?.numModificationsTotal });
});
x.displayName = "Footer";
export {
  x as default
};
//# sourceMappingURL=Footer.js.map
